var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "activity" }, [
    _c(
      "div",
      { staticClass: "activity-menu" },
      _vm._l(_vm.activetyList, function (item, i) {
        return _c(
          "div",
          {
            key: i,
            staticClass: "menu-item",
            class: { active: _vm.curIndex === i },
            on: {
              click: function ($event) {
                _vm.curIndex = i
              },
            },
          },
          [_vm._v(" " + _vm._s(item.title) + " ")]
        )
      }),
      0
    ),
    _vm.activetyList.length > 0
      ? _c("div", { staticClass: "activity-content" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.activetyList[_vm.curIndex].title)),
          ]),
          _c("div", {
            staticClass: "instructions",
            domProps: {
              innerHTML: _vm._s(
                _vm.activetyList[_vm.curIndex].content.replace(
                  "/Upload/",
                  _vm.config.imgbaseURL + "/Upload/"
                )
              ),
            },
          }),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }